import ItemSorter from "../itemSorterManager";
import SorterCriteria from "../../entity/sort/sorterCriteria";

export default class AvailabilitySorter {

    constructor() {
        this.count = 0;
        this.sortCriteria = null;
        this.getDestinations = true;
        this.emptyValues = [null, 100000000, 19700101010000];
        this.groupsList = [];
        this.extraGroupsList = [];
        this.initializedWithGetParams = false;
        this.userExclusiveInfoModal = document.querySelector("#user_exclusive[data-entity='custom-modal']");
        this.initialize();
    }


    initialize() {
        myApp.book.availabilityManager.findAllVisibleGroups().forEach((group) => {
            if (group.class === "coming_soon") {
                return;
            }

            if (group.isExtra) {
                this.extraGroupsList.push(group);
            } else {
                this.groupsList.push(group);
            }
        });

        this.eventDelegation();
        this.initializeWithGetParams();
    };

    eventDelegation() {
        $(".sorter_element").on("click", (e) => {
            const currentTarget = $(e.currentTarget);
            if (currentTarget.attr('data-field') === "distance") {
                if (!$('#user_location').hasClass('custom-modal-open')) {
                    $('[data-container="filters"]').removeClass('show');
                    $('body').removeClass('filters-opened');
                    myApp.customModalManager.openModal('#user_location');
                    return;
                } else {
                    myApp.customModalManager.closeAnimationModal('#user_location');
                }
            }
            if (currentTarget.attr('data-field') === "recommended") {
                this.restoreSort();
                return;
            }
            this.sortCriteria = null;
            this.toggleClassActive(currentTarget);
            this.setSorterCriteria(currentTarget);
            $('#filter_overlay').show();
            setTimeout(() => {
                this.doSort();
                this.refreshGetParams(currentTarget);
            }, 200);
        });

        const sorterSelectedByDefault = document.getElementById('sorterSelectedByDefault');
        if (sorterSelectedByDefault) {
            const sorterSelectionValue = sorterSelectedByDefault.value;
            const sorterSelection = document.querySelector('[data-title="' + sorterSelectionValue + '"]');
            document.querySelector('.sorter_element.active').classList.remove('active');
            sorterSelection.classList.add('active');
        }
    };

    toggleClassActive(element) {
        const sortEnabled = document.querySelector('[data-entity="sort-active"]');
        let sortField = element.attr('data-field');
        let sortOrder = element.attr('data-order');
        if (sortField === 'recommended') {
            if (sortEnabled) {
                sortEnabled.classList.add('d-none');
            }
        } else {
            if (sortEnabled) {
                sortEnabled.classList.remove('d-none');
            }
        }
        $('.sorter_element').removeClass('active');
        $('.sorter_element[data-field="' + sortField + '"][data-order="' + sortOrder + '"]').addClass('active')
        myApp.customDropdownManagerNew.closeActiveDropdowns();
    };

    checkActiveSorter() {
        if (this.sortCriteria && this.sortCriteria.field !== 'recommended') {
            return true;
        } else {
            return false;
        }
    }

    setSorterCriteria(criteria) {
        let sortField = criteria.attr('data-field');
        let sortOrder = criteria.attr('data-order');
        let sortTitle = this.checkSortingTitle(sortField, sortOrder, criteria.attr('data-title'));
        let sortType = criteria.attr('data-type');
        this.sortCriteria = new SorterCriteria(sortField, sortOrder, sortTitle, sortType);
    };

    doSort() {
        if (this.sortCriteria.field == 'distance') {
            if (this.getDestinations) {
                this.getDistance();
            }
            setTimeout(() => {
                this.sortGroups();
                this.sortChollos();
                this.printGroups();
            }, 800);
        } else {
            this.sortGroups();
            this.sortChollos();
            this.printGroups();
        }
    };

    getDistance() {
        this.itemSorter = new ItemSorter(myApp.book.availabilityManager.findAllVisibleGroups());

        $.each(this.itemSorter.sortItemsArray, (val, item) => {
            if (item.latitude && item.longitude) {
                this.getCholloDistance(item.id, item.latitude, item.longitude)
            }
        });
        this.getDestinations = false;
    };

    getCholloDistance(id, latitude, longitude) {
        let distance = myApp.locationManager.getDistanceBetweenUserAndDestination(new google.maps.LatLng(latitude, longitude));
        let container = "[data-entity='group']";
        let group = myApp.book.availabilityManager.findGroupByField('id', id);
        let textDistance = distance + ' km';
        let distanceElement = $(container + ' #distance_km_' + id + ' [data-km-distance]');

        group.distance = distance;

        $(container + '[data-id = "' + id + '"]').attr('data-distance', distance);
        $(container + ' #distance_km_' + id).removeClass('hidden');
        distanceElement.attr('data-km-distance', textDistance);
        distanceElement.text(textDistance.replace('.', ','));
    };

    sortGroups() {
        this.itemSorter = new ItemSorter(this.groupsList);
        this.itemExtraSorter = new ItemSorter(this.extraGroupsList);

        switch (this.sortCriteria.order) {
            case 'asc':
                if (this.sortCriteria.type === "object") {
                    this.itemSorter.sortByMultipleFields(this.sortCriteria.field, this.sortCriteria.order);
                    this.itemExtraSorter.sortByMultipleFields(this.sortCriteria.field, this.sortCriteria.order);
                } else {
                    this.itemExtraSorter.sortAsc(this.sortCriteria.field);
                    this.itemSorter.sortAsc(this.sortCriteria.field);
                    this.cleanAvailableList();
                }
                break;
            case 'desc':
                if (this.sortCriteria.type === "object") {
                    this.itemSorter.sortByMultipleFields(this.sortCriteria.field, this.sortCriteria.order);
                    this.itemExtraSorter.sortByMultipleFields(this.sortCriteria.field, this.sortCriteria.order);
                } else {
                    this.itemSorter.sortDsc(this.sortCriteria.field);
                    this.itemExtraSorter.sortDsc(this.sortCriteria.field);
                    this.cleanAvailableList();
                }
                break;
        }
    };

    sortChollos() {
        if ($('[data-container="chollos"]').length > 1) {
            let chollos = [];
            $.each(this.itemSorter.sortItemsArray, (i, group) => {
                chollos = new ItemSorter(group.chollos);
                switch (this.sortCriteria.order) {
                    case 'asc':
                        chollos.sortAsc(this.sortCriteria.field);
                        break;
                    case 'desc':
                        chollos.sortDsc(this.sortCriteria.field);
                        break;
                }
                $.each(chollos.sortItemsArray, (i, val) => {
                    $('[data-container="chollos"][data-chollos-group="' + group.id + '"]').append($('[data-entity="chollo"][data-id = "' + val.id + '"]'));
                });
            });
        }
    };

    cleanAvailableList() {
        let sortField = this.sortCriteria.field;
        let emptyFieldGroups = [];
        let availableGroups = [];
        $.each(this.itemSorter.sortItemsArray, (i, item) => {
            if (this.emptyValues.indexOf(item[sortField]) !== -1) {
                emptyFieldGroups.push(item);
            } else {
                availableGroups.push(item);
            }
        });
        this.itemSorter.sortItemsArray = availableGroups.concat(emptyFieldGroups);
    };

    printGroups() {
        let sorterTitle = "<div class='mb-4 mt-2 sorter-title'><span class='group-list-title text-weight-semibold text-s-24' data-entity='sorter-title'>" + this.sortCriteria.title + "</span>";
        let featuredMenuOption = document.querySelector('[data-featured-menu].featured-menu-item-active');
        var isExclusives = false;

        if (featuredMenuOption) {
            let option = featuredMenuOption.getAttribute('data-featured-menu-name');

            if (option === "exclusive") {
                isExclusives = true;
                sorterTitle +=  "<div class='valign-middle d-inline-block' data-info='exclusive'> <i class='ci ci-info-circle-inverse ci-s-22 color-secondary-medium pointer pl-2' custom-modal='#user_exclusive'></i> </div>";
            }
        }
        sorterTitle += "</div>";

        $('#filter_overlay').hide();
        if (this.itemSorter.sortItemsArray.length > 0) {
            $('.sorter-title').remove();
            $('[data-container="groups-sorted"]').append(sorterTitle);
            let iconExclusive = document.querySelector('[data-container="groups-sorted"] [data-info="exclusive"] [custom-modal="#user_exclusive"]');

            if (isExclusives && iconExclusive && this.userExclusiveInfoModal) {

                iconExclusive.addEventListener('click', () => {
                    myApp.customModalManager.openModal('#user_exclusive');
                })
            }

            $.each(this.itemSorter.sortItemsArray, (i, val) => {
                this.appendBannerBetweenElements(i, '[data-container="groups-sorted"]');
                let groupContainer = $('[data-entity="group"][data-id = "' + val.id + '"]');
                $('[data-container="groups-sorted"]').append(groupContainer);
            });
            document.querySelectorAll('[data-category]:not([data-category="coming_soon"])').forEach(element => {
                element.style.display = 'none';
            });
        }

        if (this.itemExtraSorter.sortItemsArray.length > 0) {
            $.each(this.itemExtraSorter.sortItemsArray, (i, val) => {
                let groupContainer = $('[data-entity="group"][data-id = "' + val.id + '"]');
                $('[data-container="groups-extra-sorted"]').append(groupContainer);
            });
        } else {
            this.hideElements()
        }
        myApp.book.groupsFilters.updateFiltersCounterText();
    };

    appendBannerBetweenElements(position, container) {
        $('[data-container="groups"] [data-banner]').filter((_, banner) => {
            return $(banner).data('position') === position;
        }).each((_, banner) => {
            $(container).append(banner);
            $(banner).toggle(!myApp.book.groupsFilters.checkAnyFiltersApplied());
        });
    };

    hideElements() {
        $('#menu_overlay').hide();
        $('[data-not-sortable]').hide();
        myApp.book.availabilityManager.reorderBanners();
    };

    initializeWithGetParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const sorter = urlParams.get('sorter');
        const sorterOrder = urlParams.get('sorterOrder');
        const featuredMenu = urlParams.get('featuredmenu');

        if (featuredMenu && (featuredMenu === 'best-seller' || featuredMenu === 'news')) {
            this.changeVisibleSortingOption('recommended', false);
        }

        if (sorter && sorterOrder) {
            let sorterDiv;
            if (myApp.deviceDetector.isSmScreen() || myApp.deviceDetector.isXsScreen()) {
                sorterDiv = document.querySelector('#filter .sorter_element[data-field="' + sorter + '"][data-order="' + sorterOrder + '"]');
            } else {
                sorterDiv = document.querySelector('[data-entity="sorter-lg"] .sorter_element[data-field="' + sorter + '"][data-order="' + sorterOrder + '"]')
            }
            if (sorterDiv) {
                this.initializedWithGetParams = true;
                sorterDiv.click();
            }
        }
    }

    refreshGetParams(currentTarget) {
        let getParams = new URLSearchParams(window.location.search);
        let appendSorter = true;
        for (const [key, value] of getParams.entries()) {
            if (key === 'sorter' && value === currentTarget.data('field').toString() && getParams.get('sorterOrder') === currentTarget.data('order').toString()) {
                appendSorter = false;
                break;
            }
        }

        if (appendSorter) {
            let newParams = getParams.toString();
            const newParamsStart = (newParams ? '&' : '');
            if (getParams.has('sorter')) {
                newParams = newParams.replace('sorter=' + getParams.get('sorter'), 'sorter=' + currentTarget.data('field'));
                newParams = newParams.replace('sorterOrder=' + getParams.get('sorterOrder'), 'sorterOrder=' + currentTarget.data('order'));
            } else {
                newParams += newParamsStart + 'sorter=' + currentTarget.data('field') + '&sorterOrder=' + currentTarget.data('order');
            }
            window.history.replaceState(history.state, '', '?' + newParams);
        }
    }

    restoreSort() {
        let getParams = new URLSearchParams(window.location.search);
        const allParams = getParams.keys();
        for (const key of Array.from(allParams)) {
            if (['sorter', 'sorterOrder'].includes(key)) {
                getParams.delete(key);
            }
        }

        if (getParams.size > 0) {
            window.location.href = window.location.origin + window.location.pathname + '?' + getParams.toString();
        } else {
            window.location.href = window.location.origin + window.location.pathname;
        }
    }

    checkSortingTitle(sortField, sortOrder, sorterTitle) {
        const featuredMenuOption = document.querySelector('[data-featured-menu].featured-menu-item-active');
        let title;
        if (!featuredMenuOption) {
            return sorterTitle;
        }

        const option = featuredMenuOption.getAttribute('data-featured-menu');
        switch (option) {
            case "1":
                title = myApp.translator['featured_menu.alternative.all'];
                break;
            case "2":
                title = myApp.translator['featured_menu.alternative.exclusive'];
                break;
            case "3":
                title = myApp.translator['featured_menu.alternative.news'];
                break;
            case "4":
                title = '';
                break;
            case "5":
                title = myApp.translator['featured_menu.alternative.best_seller'];
                break;
            default:
                title = sorterTitle;
                break;
        }
        return title;
    }

    changeVisibleSortingOption(option, visible) {
        const options = document.querySelectorAll('.sorter_element[data-field="' + option + '"]');
        options.forEach(option => {
            if (visible) {
                option.classList.remove('hidden');
            } else {
                option.classList.add('hidden');
            }
        })
    }
};
